export default __webpack_public_path__ + "static/logo-social-6cdbd10cb2936d339bbf58014b6038a2.jpg";